module.exports = __webpack_public_path__ + "static/aumento_liquidez-c97e6c6b3264a359373668094d866d39.png";